module.exports = __webpack_public_path__ + "media/images/rupes-nigra-DIN-400-b86f0700a1201716e010a85483052067.png";